<div #hidewhenloading class="school-home hidewhenloading mx-auto text-sm">
  <div id="step30"  class="school-card-and-description-wrap d-flex flex-column flex-md-row align-items-start">
    <div  class="school-card mw-100 bg-white rounded-md shadow-sm-darker overflow-hidden flex-shrink-0 m-auto m-md-0">
      <div class="d-flex justify-content-center">
        <img src="{{schoollogourl}}" alt="Banner image for {{schoolInfo.schoolName}}"
           class="mw-100 bg-black-100 object-cover object-center">
      </div>
      <div class="p-4 border-top">
        <div class="d-flex align-content-start">
          <i class="school-card__icon fa fa-globe text-primary-darker mr-2" title="Url"></i>
          <a href="{{this.windowProtocol}}//{{schoolInfo.subdomain}}.{{baseUrl}}" class="text-link">
            {{this.windowProtocol}}//{{schoolInfo.subdomain}}.{{baseUrl}}
          </a>
        </div>
        <div class="d-flex align-content-start mt-2">
          <i class="school-card__icon fa fa-phone-alt text-primary-darker mr-2" title="Phone"></i>
          <a href="tel:{{schoolInfo.schoolNumber}}" class="text-link">
            {{!schoolInfo.schoolNumber || schoolInfo.schoolNumber === '' ? '-' : schoolInfo.schoolNumber}}
          </a>
        </div>
        <div class="d-flex align-content-start mt-2">
          <i class="school-card__icon fa fa-envelope text-primary-darker mr-2" title="Email"></i>
          <a href="mailto:schoolinfo.schoolEmail" class="text-link">
            {{!schoolInfo.schoolEmail || schoolInfo.schoolEmail === '' ? '-' : schoolInfo.schoolEmail}}
          </a>
        </div>
      </div>
    </div>
    <div class="flex-fill w-100">
      <div #descriptiondiv [innerHTML]="descriptionhtml" class="innerHTML-wrap overflow-hidden transition" [style]="'max-height: ' + (descriptionIsExpanded ? descriptiondiv.scrollHeight : '260px')"></div>
      <div class="border-t-border-line border-black mt-{{descriptionIsExpanded ? '4' : '0'}}" [style]="'display: ' + (descriptiondiv.scrollHeight > 200 ? 'block' : 'none')">
        <button (click)="descriptionIsExpanded = !descriptionIsExpanded" class="school-description-height-toggle fa fa-angle-{{descriptionIsExpanded ? 'up' : 'down'}} bg-white rounded-circle border-0 shadow-sm-darker text-2xl text-reset d-flex mx-auto" title="Read {{descriptionIsExpanded ? 'Less' : 'More'}}"></button>
      </div>
    </div>
  </div>
  <section id="step41" class="mt-5" *ngIf="currentUserIsAdmin && displayFreePlanNotification">
    <div class="bg-white p-4 rounded shadow-sm-darker">
      You are on the free plan. You can change your plan <a routerLink="/account/schoolplan" class="text-link"><b>here</b></a>
    </div>
  </section>
  <section id="step40" class="mt-5">
    <div *ngIf="(packagesComponent && packagesComponent.hasPackages()) || currentUserIsAdmin" style="position: relative;">
      <h3 class="mb-3 text-center text-md-left">
        <span>Packages </span>
        <span>
          <button *ngIf="currentUserIsAdmin" type="button" data-toggle="dropdown" aria-expanded="false" title="Packages Info" class="top-0 m-auto align-items-center px-3 bg-transparent border-0 text-body">
              <i class="fa fa-info-circle"></i>
          </button>
          <div class="info-popup dropdown-menu p-2">
            <p class="form-info-p">A package allows you to group courses together. When a student enrolls for a package, they get access to all the courses in that package
            </p>
          </div>
        </span>
    </h3>
      <div *ngIf="currentUserIsAdmin && packagesComponent && !packagesComponent.hasPackages()" class="bg-white p-4 rounded shadow-sm-darker">
        <button routerLink='/user/editpackage' class="btn">
          <i class="fa fa-plus"></i> Create Your First Package
        </button>
      </div>
    </div>
    <app-module-packages #packagesComponent [embeded]="true"></app-module-packages>
  </section>
  <section class="mt-5">
    <h3 class="mb-3 text-center text-md-left" id="step5">Courses </h3>
    <div *ngIf="currentUserIsAdmin && modulesComponent && !modulesComponent.hasModules()" class="bg-white p-4 rounded shadow-sm-darker">
      <button routerLink='/user/editmodule' class="btn">
        <i class="fa fa-plus"></i> Create Your First Course
      </button>
    </div>
    <app-modules *ngIf="modulesURL" [modulesURL]="modulesURL" [modulesPerPage]="6" [currentUserIsAdmin]="currentUserIsAdmin" #modulesComponent></app-modules>
  </section>
</div>

<div class="modal fade" #enrolstudents id="enrolstudents" aria-hidden="true" aria-labelledby="enrolstudents" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Enrol Students</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p><a href="../../assets/templates/StudentEnrollTemplateBatched.xlsx" class="text-link text-xs"><i class="fa fa-info-circle"></i> Download Template</a></p>
        <form #uploadform="ngForm" (ngSubmit)="enrolstudent(files.files)" name="uploadform">
          <p class="text-center text-sm">{{enrolFileName || 'No File Selected'}}</p>
          <button (click)="files.click()" type="button" id="filesLabel" class="btn m-auto">Select File</button>
          <input #files (change)="enrolFileName = files.files[0]?.name" type="file" name="files" accept=".xls,.xlsx" aria-labelledby="filesLabel" id="classfile" class="sr-only" required>
          <div class="d-flex justify-content-around flex-wrap gap-1.5 mt-5">
            <button type="submit" class="btn m-0" [disabled]="files.files.length < 1">Upload</button>
            <button type="button" class="btn btn--warning m-0" (click)="closeEnrolModal()">Close</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

